import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import './index.css'
import App from './App.jsx'
import { initDarkMode } from './utils/darkMode'

initDarkMode()

// Server data cache. Defaults chosen for a CRM people keep open all day:
// refetching while someone is mid-form is more disruptive than slightly stale
// data, so window-focus refetching is off and freshness comes from explicit
// invalidation after writes.
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
})

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </StrictMode>,
)
